module.exports = __webpack_public_path__ + "img/nav5.63991aa9.svg";